import history from '../history';
import { LEAVE_HOME, GOTO_HOME, SCROLL_TO, SHOW_LOADER, ABOUT_OFFSET } from './types';

export const leaveHome = (header) => {
    return {
        type: LEAVE_HOME,
        payload: header
    }
}

export const gotoHome = () => {
    history.push('/');
    return {
        type: GOTO_HOME
    }
}

export const scrollTo = (pathName) => {
    return {
        type: SCROLL_TO,
        payload: pathName
    }
}

export const showLoader = (value = false) => {
    return {
        type: SHOW_LOADER,
        payload: value
    }
}

export const sectionOffset = (type , value) => {
    return {
        type,
        payload: value
    }
}